import { DEFAULT_TIPPY_Z_INDEX } from '../../common/tooltip/TippyTooltip';

export const PERSONALIZATION_Z_INDEX = DEFAULT_TIPPY_Z_INDEX + 1;
